import React from 'react';

import { cn } from '../../base/utils';

import type { SkeletonAnimation } from '../../skeleton/motion';

import { Skeleton } from '../Skeleton';

export interface SkeletonImageProps extends React.HTMLAttributes<HTMLDivElement> {
  animation?: SkeletonAnimation;
  /**
   * 宽度
   */
  width?: number | string;
  /**
   * 高度
   */
  height?: number | string;
  /**
   * 宽高比（当只设置宽度时使用）
   * @default '16/9'
   */
  aspectRatio?: string;
  /**
   * 圆角
   * @default 'md'
   */
  rounded?: 'none' | 'sm' | 'md' | 'lg' | 'full';
}

const roundedMap = {
  none: 'rounded-none',
  sm: 'rounded-sm',
  md: 'rounded-md',
  lg: 'rounded-lg',
  full: 'rounded-full',
};

/**
 * 图片骨架屏组件
 */
export function SkeletonImage({
  className,
  width,
  height,
  aspectRatio = '16/9',
  rounded = 'md',
  style,
  ...props
}: SkeletonImageProps) {
  return (
    <Skeleton
      className={cn(roundedMap[rounded], className)}
      style={{
        width: width,
        height: height,
        aspectRatio: !height ? aspectRatio : undefined,
        ...style,
      }}
      {...props}
    />
  );
}
